import BasePage from "@Scripts/Pages/BasePage";
import XtraVisualHelper from "@Scripts/Common/XtraVisualHelper";

export default class HomePage extends BasePage {
    public static async init() {
        await super.init();
        this.setVisuals();
    }

    private static setVisuals() {
        XtraVisualHelper.init();

        (<any>window).$(".visual-area").xtraVisual({
            timerInterval: 5000,
            isVisualLoaderEnabled: true,
            isSelectorEnabled: false,
            isTimerEnabled: true,
            isImageBackground: true,
            isSkinBackground: false,
            isSkinFullScreen: false,
            isGestureNavigation: true,
            isKeyboardNavigation: true
        });
    }
}